module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_vm._v("Man that is born of a woman hath but a short time to live … He cometh up, and is cut down, like a flower; he fleeth as it were a shadow, and never continueth in one stay.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-01a"
  }, [_vm._v("Children and the fruit of the womb are an heritage and gift … Like as the arrows in the hand of the giant: even so are the young children.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('i', [_vm._v("The Book of Common Prayer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336888be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0